"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Assigns focus to the provided element on mount or when `focusCondition` is truthy.
 * This is useful for alerting screen-reader users to page changes -
 * a common use-case would be to focus the H1 element of new screens on load.
 *
 * Make sure the provided element has a tabIndex when using this hook, and that the tabIndex is -1
 * if the element is not interactable.
 */
function useAssignFocus(elementRef, focusCondition) {
    if (focusCondition === void 0) { focusCondition = true; }
    (0, react_1.useEffect)(function () {
        var _a;
        if (focusCondition) {
            (_a = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [elementRef, focusCondition]);
}
exports.default = useAssignFocus;
